
 import adminUrls from "@/urls/admin";
import {
  sendDeleteRequest,
  sendGetRequest,
  sendPatchRequest,
  sendPostRequest
} from "@/helper/requests";
import {executeRequest} from "@/store/modules/utils";
 import {generateListUidToName} from "@/helper/uidToName";

const state = {
  date: {
    items: [],
    loading: false,
    count: 0,
    detail: [],
    error: null,
  }
};

const getters = {
  getDate: state => state.date.items,
  getDateCount: state => state.date.count,
  getCurrentUrl: state => state.date.currentUrl,
  getDateDetail: state => state.date.detail,
  isLoadingDate: state => state.date.loading,
  saveDateError: state => state.date.error,
};

const actions = {
  loadDateDetail: ({commit}, {url, event,id, finalizer=()=>{}, catcher=()=>{}}) => {
    if (!url) url = adminUrls.ADMIN.DATE.DETAIL(event,id)
    sendGetRequest(
        url, (data, url) => {
          commit('SET_DATE_DETAIL', data);
          finalizer(data, url);
        }, (data, url) => {
          commit('SAVE_DATE_ERROR', data);
          catcher(data, url);
        }
    )
  },
  loadDateList: ({commit, getters}, {url,event, urlAppend, finalizer=()=>{}, catcher=()=>{}}) => {
    commit('SET_DATE', []);
    if (!url) {
      url = adminUrls.ADMIN.DATE.LIST(event)
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingDate) {
      commit('SET_DATE_LOADING');
      sendGetRequest(
        url, (data, url) => {
          commit('SET_DATE', data);
          commit('SET_DATE_COUNT', data);
          commit('SET_DATE_LOADING_END');
          finalizer(data, url);
        }, (data, url) => {
          commit('SET_DATE_LOADING_END');
          commit('SAVE_DATE_ERROR', data);
          catcher(data, url);
        }
      )
    }
  },

  createDate: ({dispatch, commit, getters}, {event,data, finalizer=()=>{}, catcher=()=>{}}) => {
    let url = adminUrls.ADMIN.DATE.CREATE(event)
    executeRequest('Date', sendPostRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
  },
  changeDate: ({dispatch, commit, getters}, {event,id,data, finalizer,catcher}) => {
    let url = adminUrls.ADMIN.DATE.UPDATE(event,id)
    executeRequest('Date', sendPatchRequest, {url, data, finalizer, catcher}, {dispatch, commit, getters});
  },
  deleteDate: ({dispatch, commit, getters}, {event,id, finalizer, catcher}) => {
    let url = adminUrls.ADMIN.DATE.DELETE(event,id)
    executeRequest('Date', sendDeleteRequest, {url, finalizer, catcher}, {dispatch, commit, getters});
  },

};

const mutations = {

  SET_DATE: (state, obj) => {
    state.date.items = obj
  },
  SET_DATE_DETAIL: (state, value) => {
    state.date.detail = value
  },
  SET_DATE_COUNT: (state, value) => {
    state.date.count = value
  },
  SET_DATE_LOADING: (state) => {
    state.date.loading = true
  },
  SET_DATE_LOADING_END: (state) => {
    state.date.loading = false
  },
  SAVE_DATE_ERROR: (state, error) => {
    state.date.error = error
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}


